// Strip Curtain Weight Calculator
(function() {
  const divisors = [
    [166.67, 125, 100],
    [166.67, 125, 100],
    [243.75, 177, 139],
    [230.77, 157.90, 120],
    [285.71, 181.82, 133.33],
    [285.71, 181.82, 133.33],
    [230.77, 157.89, 120],
    [230.77, 157.89, 120],
    [230.77, 157.90, 120],
    [230.77, 157.90, 120],
    [166.67, 125, 100],
    [166.67, 125, 100],
    [166.67, 125, 100]
  ];

  const weightPerM = [0.74, 0.74, 1.08, 1.08, 1.46, 1.46, 1.10, 1.10, 0.74, 0.74, 0.48, 0.48, 0.48];
  let initialized = false;

  function createWeightDisplay() {
    let weightDisplay = document.getElementById('weight-display');
    if (!weightDisplay) {
      weightDisplay = document.createElement('p');
      weightDisplay.id = 'weight-display';
      weightDisplay.style.cssText = 'margin: 0;';
      weightDisplay.innerHTML = '<b>Weight:</b> <span id="weight-value" style="color:#222;">0 kg</span>';
      const priceWrapper = document.querySelector('.final_price_wrapper');
      if (priceWrapper) priceWrapper.parentNode.insertBefore(weightDisplay, priceWrapper);
    }

    // Add hidden input for cart
    let weightInput = document.getElementById('weight-input');
    if (!weightInput) {
      weightInput = document.createElement('input');
      weightInput.type = 'hidden';
      weightInput.id = 'weight-input';
      weightInput.name = 'properties[Weight]';
      weightInput.value = '0 kg';
      const form = document.querySelector('form[action*="/cart/add"]') || document.getElementById('calc-form-preview');
      if (form) form.appendChild(weightInput);
    }

    return weightDisplay;
  }

  function calculateWeight() {
    const width = parseFloat(document.querySelector('input[name="width"]')?.value) || 0;
    const height = parseFloat(document.querySelector('input[name="height"]')?.value) || 0;
    const stripType = parseInt(document.querySelector('select[name="strip_type"]')?.value);
    const overlapEl = document.querySelector('input[name="strip_overlap"]:checked');
    const overlap = overlapEl ? parseInt(overlapEl.value) : 0;

    const weightValue = document.getElementById('weight-value');
    const weightInput = document.getElementById('weight-input');
    
    if (!weightValue) return;

    if (width <= 0 || height <= 0 || isNaN(stripType)) {
      weightValue.textContent = '0 kg';
      if (weightInput) weightInput.value = '0 kg';
      return;
    }

    const divisor = divisors[stripType][overlap];
    const strips = width / divisor;
    const heightM = height / 1000;
    const railWeight = (width + 100) / 1000 * 1.20;
    const weight = (strips * heightM * weightPerM[stripType]) + railWeight;

    const weightText = weight.toFixed(1) + ' kg';
    weightValue.textContent = weightText;
    if (weightInput) weightInput.value = weightText;
  }

  function init() {
    if (initialized) return;
    const form = document.getElementById('calc-form-preview');
    if (form) {
      initialized = true;
      createWeightDisplay();
      form.addEventListener('change', calculateWeight);
      form.addEventListener('input', calculateWeight);
    }
  }

  const observer = new MutationObserver(function() {
    if (document.querySelector('.final_price_wrapper')) {
      init();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  init();
})();